import ActionTypes from '../constants/ActionTypes';

export const uploadProgressBar = ({ progress, problemSlug }) => ({
  type: `${ActionTypes.VIDEO_UPLOAD}_PROGRESS`,
  progress,
  problemSlug,
});
export const setWaitTillVideoSubmit = flag => ({
  type: flag
    ? `${ActionTypes.WAIT_TILL_VIDEO_SUBMIT}_SUCCESS`
    : `${ActionTypes.WAIT_TILL_VIDEO_SUBMIT}_FAIL`,
});
